package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.FormInputStyle
import io.horion.cv.styles.FormLabelStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement

@Composable
fun TextFormField(
    label: String,
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    placeholder: String = "",
    enabled: Boolean = true,
    inputRef: ((HTMLInputElement) -> Unit)? = null,
    inputId: String? = null
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(0.px)
    ) {
        SpanText(
            text = label,
            modifier = FormLabelStyle.toModifier()
                .color(if (isDark) Colors.White else Colors.Primary)
        )
        Input(
            type = InputType.Text,
            attrs = FormInputStyle.toModifier()
                .toAttrs {
                    if (inputId != null) {
                        id(inputId)
                    }

                    value(value)
                    if (placeholder.isNotEmpty()) {
                        attr("placeholder", placeholder)
                    }
                    if (!enabled) {
                        attr("disabled", "")
                    }

                    onInput { event ->
                        if (enabled) {
                            onValueChange(event.value)
                        }
                    }

                    ref { element ->
                        inputRef?.invoke(element)
                        onDispose { }
                    }
                }
        )
    }
}